import { PLATFORM } from 'aurelia-pal';

const odsMenu = PLATFORM.moduleName('olapic-design-system/elements/menu/aurelia/odsMenu');
const odsSearchBox = PLATFORM
.moduleName('olapic-design-system/elements/searchBox/aurelia/odsSearchBox');
/**
 * Registers all the Olapic Design System's components the app needs access to.
 * @param {Aurelia} aurelia The application information.
 */
export const configure = (aurelia) => {
  // Resources
  aurelia.globalResources(
    odsMenu,
    odsSearchBox,
  );
};
